import { useState } from 'react';

const FAQ_ITEMS = [
  {
    q: '90影院的影视资源需要付费吗？',
    a: '完全不需要。90影院所有电影、电视剧、综艺、动漫、纪录片资源均免费在线观看，无需注册登录，无需任何付费，打开即可观看。我们通过广告收入维持运营，始终坚持为用户提供免费的优质观影体验。',
  },
  {
    q: '为什么有些影片播放时会卡顿或加载慢？',
    a: '90影院采用多线路智能分流技术，如果当前线路播放不流畅，您可以手动切换其他播放线路。建议在设置中选择与您网络环境匹配的画质档位（高清/超清/4K/蓝光），一般家庭宽带建议选择超清或高清档以获得最佳流畅度。',
  },
  {
    q: '支持哪些设备观看？可以在电视上播放吗？',
    a: '90影院全面适配手机、平板、电脑等设备，浏览器直接打开即可观看，无需安装任何软件。如需在电视上观看，可通过手机投屏或电脑HDMI连接电视实现大屏观影。我们也在持续优化移动端和TV端的适配体验。',
  },
  {
    q: '影片更新频率是怎样的？新片多久能上线？',
    a: '编辑团队每日精选更新，平均日更30部以上。热门院线影片通常在网络上线后24小时内完成收录，国产剧和综艺在首播后次日即可观看，动漫同步日本更新。您可以通过"更新快讯"模块查看最新上线内容。',
  },
  {
    q: '如何查找我想看的特定影片？',
    a: '您可以通过首页的"专题索引"按分类快速定位感兴趣的类型，也可以通过"热度榜单"发现大家都在看的热门内容。页面顶部的搜索功能支持影片名称、导演、演员等多维度搜索，帮助您快速找到目标影片。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">常见问答</h2>
            <p className="mt-2 text-sm text-foreground-500">关于90影院的常见问题，这里都能找到答案</p>
          </div>

          <div className="max-w-2xl mx-auto space-y-3">
            {FAQ_ITEMS.map((item, i) => (
              <div
                key={i}
                className="rounded-xl bg-background-50 border border-background-200/60 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-background-200/30 transition-colors cursor-pointer"
                >
                  <h3 className="text-sm font-semibold text-foreground-900 pr-4">{item.q}</h3>
                  <i
                    className={`ri-arrow-down-s-line text-lg text-foreground-400 flex-shrink-0 transition-transform duration-200 ${
                      openIndex === i ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-500 leading-relaxed">{item.a}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}